import { createI18n } from 'vue-i18n';

const messages = {
    en: {
        navigation: {
            home: "Home",
            about: "About Us",
            products: "System Content",
            join: "Contact Us",
            partner: "Partners"
        },
        slide1: {
            title: "Selenium, an essential trace element for the human body",
            text: "The need for selenium supplementation is urgent for everyone",
            more: "Learn More",
        },
        slide2: {
            title: "Make selenium supplementation as widespread as iodine supplementation",
            text: "Start the era of scientific selenium supplementation for everyone",
            more: "Learn More",
        },
        slide3: {
            title: "The third-generation natural organic selenium – water-soluble selenium protein",
            text: '',
            more: "Learn More",
        },
        brand: {
            text: "We provide a SaaS system for businesses that ensures the security of funds, information, and logistics traceability data during transactions, as well as compliance with product sales data. Our main focus is on developing data products and related services for the health industry, including 'medicinal food homology product transactions' and 'agricultural product transactions', offering services such as tax, settlement, and account allocation."
        },
        titles: {
            brand: 'System Application Scope',
            aboutUs: 'About Us',
            mobileEnergyStation: 'System Introduction',
            brandIntro: 'Brand Introduction',
            restaurantImages: 'Restaurant Images',
            productImages: 'Product Images',
            joinCenter: 'Franchise Center'
        },
        aboutUs: {
            titlePrefix: "China",
            highlightText: "Selenium",
            titleSuffix: "High-quality Industry Development",
            leadershipText: "Leader",
            dataPoints: {
                foundingYear: "Huixin Group founded in 2024",
                customers: "Number of customers served",
                partners: "Partners"
            },
            description: "[Huijie Ark] platform, as a pioneer in the public and private domain integration, has integrated with the national banking and taxation systems. Through big data ERP systems and nationwide industry digital interconnection, it has created a new business model for internet data sharing between B2B and B2C.",
            imageAlt: "Company Office Environment"
        },
        mobileEnergyStation: {
            title: "One-stop SaaS Data Service System for Transaction Tax Settlement and Account Allocation",
            listItems: {
                travelAndProfit: "Strategic Value",
                lightAssetOperation: "Assisting in Modernizing Tax Governance",
                stressFreeStartup: "Activating Small and Micro Enterprises",
                projectDescription: "Enhancing Supply Chain Autonomy"
            },
            buttonText: "Learn More"
        },
        footer: {
            aboutUs: {
                title: "About Us",
                paragraphs: {
                    aboutHuiXin: "About Huixin"
                }
            },
            contactUs: {
                title: "Contact Us",
                paragraphs: {
                    address: "Address: Room 1104, Building 23, Tian'an Headquarters Center, No. 555 Panyu Avenue, Panyu District, Guangzhou",
                    phone: "Customer Service: 400 875 1331"
                }
            },
            followUs: {
                title: "Follow Us",
                qrCodes: {
                    alt1: "QR Code 1",
                    alt2: "QR Code 2"
                }
            },
            filings: {
                text: "© Guangdong Huixin Data Management Co., Ltd. All rights reserved | ",
                links: {
                    icp: "ICP Filing: 粤ICP备2025420018号",
                    publicSecurity: "Public Security: 粤公网安备 44000000000000号"
                }
            }
        },
        about: {
            title: "About Us",
            tabs: {
                company: "Company Profile",
                development: "Development History",
                founder: "Founder Introduction",
                operation: "Operations Team"
            }
        },
        company: {
            title: "Company Overview",
            title2: "Core Business",
            bottomText: "Huixin Kangshanyang is committed to building a closed loop in the health adjustment market, offering one-stop services from diagnosis to health management. We believe health is not only the goal of life, but also the source of happiness. Therefore, we invite you to join the Huixin Kangshanyang family, explore the path to health, and enjoy a beautiful life. Here, you will find that health is actually very simple, in your daily meals and every health diagnosis by technology.",
            description: [
                "Huixin Kangshanyang is your trusted partner in holistic health. We combine traditional wisdom with modern technology to create a comprehensive health management platform.",
                "On the front end, we introduce cutting-edge AI Traditional Chinese Medicine (TCM) technology, using high-tech smart devices to provide precise and convenient health diagnostics, bringing ancient TCM wisdom to life. On the back end, we have developed a range of herbal teas, nourishing soups, and medicinal dishes based on TCM theories, aiming to restore and maintain optimal body conditions through daily dietary adjustments."
            ],
            contentTitles: {
                huize: "Core Business",
                shicai: "Cooperation Models & Legal Protection",
                zhishui: "Company Vision",
                lianlu: "Contact Us"
            }
        },
        develop: {
            introText: "Huixin was officially established in June 2024, but our story and vision began quietly in 2021.",
            imageAlt: "Company Background Image",
            companyInfo: {
                year: "2024",
                foundingLabel: "Company Founded",
                brands: "3 Brands",
                brandLabel: "Brands Under Our Belt"
            }
        }
    },
    
    zh: {
        navigation: {
            home: "首页",
            about: "关于我们",
            products: "系统内容",
            join: "加入我们",
            partner: "合作伙伴"
        },
        slide1: {
            title: '硒，人体不可缺少的微量元素',
            text: '全民补硒刻不容缓',
            more: '了解更多',
        },
        slide2: {
            title: '让补硒像补碘一样普及',
            text: '开启全民科学补硒时代',
            more: '了解更多',
        },
        slide3: {
            title: '第三代天然有机硒-水溶硒蛋白',
            text: '',
            more: '了解更多',
        },
        brand: {
            text: '为企业提供交易过程中的资金数据安全，信息数据安全、物流溯源数据安全，产品销售信息数据合规的SaaS系统，主要开发大健康板块中‘药食同源产品交易’及‘农副产品交易’的数据产品及相关服务，不限于完税、结算、分账功能的技术服务商'
        },
        titles: {
            brand: '系统应用范围',
            aboutUs: '关于我们',
            mobileEnergyStation: '系统介绍',
            brandIntro: '品牌简介',
            restaurantImages: '餐厅图片',
            productImages: '产品图片',
            joinCenter: '加盟中心'
        },
        aboutUs: {
            titlePrefix: "中国",
            highlightText: "硒",
            titleSuffix: "产业高质量发展",
            leadershipText: "领军者",
            dataPoints: {
                foundingYear: "惠信集团创始于2024年",
                customers: "服务客户数量",
                partners: "合作伙伴"
            },
            description:
                "[惠界方舟]平台，作为公私域互通的先行者，已跟国家银联系统及国家税务系统相结合，通过大数据ERP系统+全国产业数字化互联方式实现B端C端共享的互联网数据新业态。",
            imageAlt: "公司办公环境"
        },
        mobileEnergyStation: {
            title: "一站式解决交易完税结算分账的SaaS数据服务系统",
            listItems: {
                travelAndProfit: "战略价值",
                lightAssetOperation: "助力税收治理现代化",
                stressFreeStartup: "激活中小微企业活力",
                projectDescription: "增强供应链自主可控"
            },
            buttonText: "了解更多"
        },
        footer: {
            aboutUs: {
                title: "关于我们",
                paragraphs: {
                    aboutHuiXin: "关于惠信"
                }
            },
            contactUs: {
                title: "联系我们",
                paragraphs: {
                    address: "地址：广州市番禺区东环街迎宾路730号番禺节能科技园内天安科技产业大厦2座407房",
                    phone: "客服电话：400 875 1331"
                }
            },
            followUs: {
                title: "关注我们",
                qrCodes: {
                    alt1: "二维码1",
                    alt2: "二维码2"
                }
            },
            filings: {
                text: "惠信数据技术（广东）有限公司版权所有 | ",
                links: {
                    icp: "网站备案: 粤ICP备2025420018号",
                    publicSecurity: "粤公网安备 44000000000000号"
                }
            }
        },
        about: {
            title: "关于我们",
            tabs: {
                company: "公司简介",
                development: "发展历程",
                founder: "创始人介绍",
                operation: "运营团队"
            }
        },
        company: {
            title: "企业概况",
            title2:"核心业务",
            bottomText: "惠信康膳养致力于构建健康调理市场的闭环，从诊断到调理，一站式满足您的健康需求。我们相信，健康不仅是生活的目标，更是幸福的源泉。因此，我们诚邀您加入惠信康膳养的大家庭，一同探索健康之道，享受美好人生。在这里，您将发现，健康其实很简单，就在您的一日三餐与每一次的科技诊疗之中。",
            description: [
                "惠信康膳养，是您身边的大健康守护者。我们融合传统智慧与现代科技，打造一个全方位的健康管理平台。",
                "前端，我们引入前沿AI中医技术，通过高科技的智能仪器,为您提供精准、便捷的健康诊疗服务,让古老的中医智慧焕发新生。后端,我们精心研发了一系列中药茶饮、养生炖汤与药膳蒸菜,这些产品均基于中医理论,旨在通过日常饮食调理,助您恢复与维持身体最佳状态。"
            ],
            contentTitles: {
                huize: "核心业务",
                shicai: "合作模式与法律保障",
                zhishui: "企业愿景",
                lianlu: "联系我们"
            }
        },
        develop: {
            introText: "惠信正式成立于2024年6月，但我们的故事和愿景，早在2021年已悄然拉开序幕。",
            imageAlt: "公司背景图",
            companyInfo: {
                year: "2024年",
                foundingLabel: "公司成立",
                brands: "3家",
                brandLabel: "旗下品牌"
            }
        }
    }
};

const i18n = createI18n({
    legacy: false,
    locale: 'zh',
    fallbackLocale: 'en',
    messages
});

export default i18n;